function firstLetterUpperCase(string: string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
  return string;
}

/**
 * Contains special translations for the spaced capitalization we should replace - word/phrase to search 
 * on the left side, replacement on the right.
 */
const SPECIAL_CASED_WORDS: Record<string, string> = {
  oauth: "OAuth",
  api: "API",
};

/**
 * Converts a `snake_case_string` to `Snake Case String`, making sure to "translate" any special words that
 * require a different capitalization than just uppercasing the first letter.
 */
export const snakeCaseToSpacedCapitalized = (text: string) => {
  return text
    .split("_")
    .map((word) => SPECIAL_CASED_WORDS[word] ?? firstLetterUpperCase(word))
    .join(" ");
};

